import { canShowSketchPropertySection, handleSketchEntityPropertyConfirm, registerPropertyManagerSection } from '@/core';
import { SketchArcCommand } from '@puppycad/cad-core';
import ArcPropertySection from '@/components/editor/property-manager/arc/ArcPropertySection.vue';

registerPropertyManagerSection({
  id: SketchArcCommand.CenterStartEnd,
  title: '圆弧',
  order: 13,
  component: ArcPropertySection,
  actions: {
    confirm: true,
  },
  onConfirm: handleSketchEntityPropertyConfirm,
  isApplicable: (context) => canShowSketchPropertySection(context, context.arcPropertyVisible === true),
});
